module.exports = __webpack_public_path__ + "static/media/Roboto-Light.ed4b08d2.woff2";